import { Component, OnInit } from '@angular/core';
import { DashboardService} from '../dashboard.service';
import { Router} from '@angular/router';
import { NameValueDto } from '@ig-core/interfaces/name-value-dto';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BranchService } from '@app/admin/branch/branch.service';
import { ReferenceCodeService } from '@app/admin/reference-code/reference-code.service';
import { ReferenceCode } from '@app/admin/reference-code/reference-code.model';
@Component({
  selector: 'eng-approval-queue',
  templateUrl: './approval-queue.component.html',
  styleUrls: ['./approval-queue.component.scss', '../dashboard.component.scss']
})
export class ApprovalQueueComponent implements OnInit {
  dashboardData:any;
  hideTables:boolean=false;
  showAllStages:boolean=false;
  statesAndBranch: any;
  fieldSearchForm: FormGroup;  
  loanTypes: NameValueDto[] = [];
  settingsList: ReferenceCode[]
  modtStages: any;
  stateBranchMap: { [key: string]: string[] } = {};
  constructor(private dashboardService:DashboardService,private router:Router,
    private formBuilder: FormBuilder,
    private branchService:BranchService,
    private referenceCodeService:ReferenceCodeService) { }

  ngOnInit() {
    // Initialize the form with empty values and default branch
    this.fieldSearchForm = this.formBuilder.group({
      login: '',
      branches: '', // Set the default value here
      states: '',
      product: ''
    });
    this.getStateAndBranches();
    this.getDashboardData();
    this.getRefCodes();
  }
//get Dashboard related data

getDashboardData(){
  let branches = this.fieldSearchForm.value.branches;
  let login = this.fieldSearchForm.value.login.trim();
  let states = this.fieldSearchForm.value.states;
  let productType = this.fieldSearchForm.value.product;

  // if user select all and click on show then it will send option 'all' as well,
  // hence we are removing 'all' from selected branches if 'all' is included
  if (branches.includes('all')) {
    branches = branches.filter(option => option !== 'all');
  }
  if (states.includes('all')) {
    states = states.filter(option => option !== 'all');
  }
  this.dashboardService.getDashboradDataStagewise(branches, login,productType,states).subscribe(response=>{
  this.dashboardData =response.body
  if(this.dashboardData.status == "failure"){
    this.hideTables=true
  }
  })
}


    goToApplicationList(item){ 
      let searchCriteria ={"applicationDateFrom":'',"show":"ALL","stages":[],"productType":[],"branch":[],"salesPersonId":'',"modtStatus": []}
      // for DOCUMENT EXECUTION legal verification also we need to show DOCUMENT EXECUTION stage application since for other applicaiton list
      // we are passing the same name as stage but for legal verificaiton we need to pass DOCUMENT EXECUTION
      let stage = item.startsWith('DOCUMENT EXECUTION') ? 'DOCUMENT EXECUTION' : item;
      // MODT is not an actual application stage. The applicable stages for MODT are configured in the
      // MODT-STAGES refCode. Search using those stages along with MODT status as PENDING.
      if (stage.toUpperCase().includes('MODT')) {
        searchCriteria.stages = this.modtStages;
        searchCriteria.modtStatus = ["PENDING"];
      } else {
        searchCriteria.stages.push(stage);
      }
      searchCriteria.productType = this.fieldSearchForm.controls.product.value;
      searchCriteria.salesPersonId = this.fieldSearchForm.controls.login.value;
      let selectedStates = this.fieldSearchForm.controls.states.value || [];
      let selectedBranches = this.fieldSearchForm.controls.branches.value || [];

      // When a state is selected, include all branch codes linked to that state
      // in the search criteria. This is required to ensure the application count
      // displayed on the dashboard should matche the count in the application list.
      if (selectedStates.length > 0) {
        let branchesFromSelectedStates = [];

        selectedStates.forEach(stateCode => {
          branchesFromSelectedStates = branchesFromSelectedStates.concat(
            this.stateBranchMap[stateCode] || []
          );
        });

        // Combine state-linked branches with individually selected branches and remove any duplicate branch codes.
        searchCriteria.branch = branchesFromSelectedStates.concat(
          selectedBranches.filter((branch, index, allBranches) => allBranches.indexOf(branch) === index )
        );
        } else {
        // If no state is selected, send only the branches selected directly
        searchCriteria.branch = selectedBranches;
      }
      this.dashboardService.updateSearchCriteria(searchCriteria)
      this.router.navigateByUrl(`applications`)
    }

  getStateAndBranches() {
    this.branchService.getStatesAndBranches().subscribe((response: any) => {
      if (response && response.body) {
        const data = response.body;

        this.statesAndBranch = {
          states: data.map(state => ({
            code: state.stateCode,
            name: state.stateName
          })),
          branches: data.flatMap(state => state.branches || [])
        };

        this.stateBranchMap = data.reduce((map, state) => {
          map[state.stateCode] = state.branches.map(branch => branch.code);
          return map;
        }, {});
      }
    });
  }

  handleAllOption(controlName: string, options: any[]) {
    let selectedOptions = this.fieldSearchForm.value[controlName];

    if (selectedOptions.includes('all')) {
      // If "ALL" is selected, select all other options
      let allCodes = options.map(option => option.code);
      let selectedValues = allCodes.concat('all');

      this.fieldSearchForm.get(controlName).setValue(selectedValues);
    } else {
      // If "ALL" is not selected, set the form value with empty, this will deselect all the options
      this.fieldSearchForm.get(controlName).setValue([]);
    }
  }

  selectedValues(controlName: string, options: any[]) {
    let selectedOptions = this.fieldSearchForm.value[controlName];

    // this filter we are doing to uncheck "all" option if we uncheck any one value after clicking "all"
    let updatedSelection = selectedOptions.filter(option => option !== 'all');
    this.fieldSearchForm.get(controlName).setValue(updatedSelection);

    // this we are checking beacause if we select all the dropdown values that is nothing but selectAll option
    // hence adding "all" so that option "all" will be checked
    if (updatedSelection.length === options.length) {
      let selectedValue = updatedSelection.concat('all');
      this.fieldSearchForm.get(controlName).setValue(selectedValue);
    }
  }

  getRefCodes(){
    this.referenceCodeService.getRefCodesForClassifier('loan_type').subscribe((response: any) => {
      this.loanTypes = response
    });

    this.referenceCodeService.getRefCodesForClassifier('settings').subscribe((response: any) => {
      this.settingsList = response
      this.settingsList.forEach(element => {
        if (element.code === 'MODT-STAGES' && element.field1 !== null && element.field1 !== '') {
          this.modtStages = element.field1.split(',').map(stage => stage.trim());
        }
      });
    })
  }
}
